import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiUrl } from 'env';

axios.defaults.baseURL = apiUrl;
axios.defaults.headers.common['app-source'] = 'IntakeApp';
axios.interceptors.request.use((config: AxiosRequestConfig) => {
  const updatedConfig: AxiosRequestConfig = {
    ...config,
    headers: {
      ...config.headers,
    },
  };
  return updatedConfig;
});
export const axiosRequestInstance = axios.create();
const request = async <T>(
  url: string,
  config: AxiosRequestConfig,
): Promise<T> => axiosRequestInstance
  .request<T>({
    url,
    ...config,
  })
  .then((res: AxiosResponse) => res.data)
  .catch((error) => {
    const errorMessage = 'Something went wrong during processing your request. Please contact your provider.';
    if (error?.response?.status >= 500) {
      throw new AxiosError(
        errorMessage,
        error.response.status,
      );
    }
    throw new AxiosError(
      error?.response?.data ?? errorMessage,
      error?.response?.status,
    );
  });

export { request };
